import { css } from '@wanteddev/wds-engine';
import objectPath from 'object-path';
import { respondMore } from './media.mjs';

// src/utils/responsive-props.ts
var order = ["xs", "sm", "md", "lg", "xl"];
var createEmptyResponsiveStyle = (responsive) => (theme) => css`
    ${createResponsiveStyle(
  responsive,
  theme
)(
  (params) => css`
        ${params?.sx}
      `
)}
  `;
var createResponsiveStyle = (responsive, theme) => (cb) => {
  return css`
      ${Object.entries(responsive).sort(([a], [b]) => {
    return order.findIndex((v) => v === a) - order.findIndex((v) => v === b);
  }).map(([bp, value]) => {
    if (!value || !Object.values(value).some((v) => v !== void 0)) {
      return;
    }
    const breakpoint = bp;
    switch (breakpoint) {
      case "xs":
        return css`
                ${respondMore(theme.breakpoint.xs)} {
                  ${cb(value, "xs")}
                }
              `;
      case "sm":
        return css`
                ${respondMore(theme.breakpoint.sm)} {
                  ${cb(value, "sm")}
                }
              `;
      case "md":
        return css`
                ${respondMore(theme.breakpoint.md)} {
                  ${cb(value, "md")}
                }
              `;
      case "lg":
        return css`
                ${respondMore(theme.breakpoint.lg)} {
                  ${cb(value, "lg")}
                }
              `;
      case "xl":
        return css`
                ${respondMore(theme.breakpoint.xl)} {
                  ${cb(value, "xl")}
                }
              `;
    }
  })};
    `;
};
var getPreviousValue = (params, key, defaultValue, breakpoint) => {
  switch (breakpoint) {
    case "xl":
      return objectPath.get(params.xl || {}, key) ?? objectPath.get(params.lg || {}, key) ?? objectPath.get(params.md || {}, key) ?? objectPath.get(params.sm || {}, key) ?? objectPath.get(params.xs || {}, key) ?? defaultValue;
    case "lg":
      return objectPath.get(params.lg || {}, key) ?? objectPath.get(params.md || {}, key) ?? objectPath.get(params.sm || {}, key) ?? objectPath.get(params.xs || {}, key) ?? defaultValue;
    case "md":
      return objectPath.get(params.md || {}, key) ?? objectPath.get(params.sm || {}, key) ?? objectPath.get(params.xs || {}, key) ?? defaultValue;
    case "sm":
      return objectPath.get(params.sm || {}, key) ?? objectPath.get(params.xs || {}, key) ?? defaultValue;
    case "xs":
    default:
      return objectPath.get(params.xs || {}, key) ?? defaultValue;
  }
};

export { createEmptyResponsiveStyle, createResponsiveStyle, getPreviousValue };
